import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet";
import "aos/dist/aos.css";
import "../css/Blogs.css"; // Custom CSS for hover animation

const Blogs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS with a duration of 1000ms
  }, []);

  return (
    <>
      <Helmet>
        <title>Blogs | Lone Wolf Writes</title>
        <meta name="description" content="Lone Wolf Writes Blogs" />
        <link rel="canonical" href="https://lonewolfwrites.com/blogs" />
      </Helmet>
      <main>
        <div className="container">
          <div className="row mt-4">
            <div className="col-md-8" data-aos="fade-right" >
              <div className="card blog-card mb-4"
                style={{ height: "540px", backgroundColor: "#EEE6E6", border: "none" }} >
                <a href="blogs/the-evolution-of-romantic-poetry">
                  <picture>
                    <img className="img-fluid rounded" src="/media/blogs/the-evolution-of-romantic-poetry-from-then-to-now.jpg" alt=" The Evolution of Romantic Poetry: From Then to Now | Lone Wolf writes " style={{ height: "480px", width: "100%", objectFit: "cover" }} />
                  </picture>
                </a>
                <div className="textarea mt-2">
                  <a href="blogs/the-evolution-of-romantic-poetry" style={{ textDecoration: 'none', color: '#232323' }}>The Evolution of Romantic Poetry: From Then to Now</a>
                </div>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-left">
              <div className="card blog-card mb-2" style={{ height: "50px", backgroundColor: "#FFF0F0", border: "none", borderRadius: "0", width: "100%", objectFit: "cover" }} >
                <div className="textarea mt-2">
                  <h1 style={{ marginLeft: "20px", fontSize: "largest" }}>Blogs</h1>
                </div>
              </div>
              <a href="blogs/poetry-as-therapy" style={{ textDecoration: 'none', color: '#232323' }}>
                <div className="card blog-card mb-2" style={{ height: "90px", backgroundColor: "#F5F5F5", border: "none", borderRadius: "0", width: "100%", objectFit: "cover" }} >
                  <div className="textarea mt-3" style={{ marginLeft: "20px" }}>
                    Poetry as Therapy: Healing Through Words
                  </div>
                </div>
              </a>
              <a href="blogs/top-10-timeless-poems" style={{ textDecoration: 'none', color: '#232323' }}>
                <div className="card blog-card mb-2"
                  style={{ height: "90px", backgroundColor: "#F5F5F5", border: "none", borderRadius: "0", width: "100%" }} >
                  <div className="textarea mt-3" style={{ marginLeft: "20px" }}>
                    Top 10 Timeless Poems That Resonate Across Generations
                  </div>
                </div>
              </a>
              <a href="blogs/the-power-of-words" style={{ textDecoration: 'none', color: '#232323' }}>
                <div className="card blog-card mb-2" style={{ height: "90px", backgroundColor: "#F5F5F5", border: "none", borderRadius: "0", width: "100%" }} >
                  <div className="textarea mt-3" style={{ marginLeft: "20px" }}>
                    The Power of Words: How a Simple Quote Can Change Your Day
                  </div>
                </div>
              </a>
              <a href="blogs/famous-poets-and-the-stories-behind-their-masterpiece" style={{ textDecoration: 'none', color: '#232323' }}>
                <div className="card blog-card mb-2" style={{ height: "90px", backgroundColor: "#F5F5F5", border: "none", borderRadius: "0", width: "100%" }} >
                  <div className="textarea mt-3" style={{ marginLeft: "20px" }}>
                    Famous Poets and the Stories Behind Their Masterpieces
                  </div>
                </div>
              </a>
              <a href="blogs/inspirational-quotes-for-every-stage" style={{ textDecoration: 'none', color: '#232323' }}>
                <div className="card blog-card mb-2" style={{ height: "90px", backgroundColor: "#F5F5F5", border: "none", borderRadius: "0", width: "100%" }} >
                  <div className="textarea mt-3" style={{ marginLeft: "20px" }}>
                    Inspirational Quotes for Every Stage of Life
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-md-4" data-aos="fade-up">
              <div className="card blog-card" style={{ height: "300px", backgroundColor: "#EEE6E6", border: "none" }} >
                <a href="blogs/from-thoughts-to-verse">
                  <picture>
                    <img className="img-fluid rounded" src="/media/blogs/from-thought-to-verse-a-beginner’s-guide-to-writing-poetry.jpg" alt=" From Thought to Verse: A Beginner’s Guide to Writing Poetry | Lone Wolf writes " style={{ height: "240px", width: "100%" }} />
                  </picture>
                </a>
                <div className="textarea mt-2">
                  <a href="blogs/from-thoughts-to-verse" style={{ textDecoration: 'none', color: '#232323', objectFit: "cover" }}>From Thought to Verse: A Beginner’s Guide to Writing Poetry</a>
                </div>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
              <div className="card blog-card" style={{ height: "300px", backgroundColor: "#EEE6E6", border: "none" }} >
                <a href="blogs/craft-quotes-that-speak-volumes">
                  <picture>
                    <img className="img-fluid rounded" src="/media/blogs/how-to-craft-quotes-that-speak-volumes.jpg" alt=" How to Craft Quotes That Speak Volumes | Lone Wolf writes " style={{ height: "240px", width: "100%" }} />
                  </picture>
                </a>
                <div className="textarea mt-2">
                  <a href="blogs/craft-quotes-that-speak-volumes" style={{ textDecoration: 'none', color: '#232323', objectFit: "cover" }}>How to Craft Quotes That Speak Volumes</a>
                </div>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="400">
              <div className="card blog-card" style={{ height: "300px", backgroundColor: "#EEE6E6", border: "none" }} >
                <a href="blogs/creative-ways-to-display-quotes">
                  <picture>
                    <img className="img-fluid rounded" src="/media/blogs/famous-poets-and-the-stories-behind-their-masterpieces.jpg" alt=" Creative Ways to Display Quotes in Your Home or Office | Lone Wolf writes " style={{ height: "240px", width: "100%", objectFit: "cover" }} />
                  </picture>
                </a>
                <div className="textarea mt-2">
                  <a href="blogs/creative-ways-to-display-quotes" style={{ textDecoration: 'none', color: '#232323' }}>Creative Ways to Display Quotes in Your Home or Office</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Blogs;
